<template>
    <main id="teinte">
        <section id="teinteDesktop">
            <div id="Teinte" class="rel">
                <h3 id="title" class="txtCenter ff-medium rel">
                    {{ $t("shades.title") }}
                    <button id="edit" class="btn abs pointer mobileNot ff-light" @click="modalShades();" v-if="hasAccessCreate('shade_manager')">
                        {{ $t("shades.add") }}
                    </button>
                    <div
                        class="uploader-form btn abs pointer mobileNot ff-light"
                        v-if="loading === false && hasAccessUpdateAndCreate('shade_manager')"
                    >
                        <form enctype="multipart/form-data" :action="actionUrl" novalidate v-on:submit.prevent>
                            <div class="uploader-form-input">
                                <input
                                    ref="fileUpload"
                                    id="fileUpload"
                                    type="file"
                                    :name="uploadFieldName"
                                    class="hidden"
                                    @change="
                                        onSubmit($event.target);
                                        fileCount = $event.target.files.length;
                                    "
                                    accept=".xlsx, .xls"
                                />
                                <span @click="chooseFiles();">{{ $t("shades.import") }}</span>
                            </div>
                        </form>
                    </div>
                    <span class="arrows mobileOnly abs" @click="showShades">
                        <img id="upArrow" class="fright" src="../../assets/chev-up.png" alt="" v-if="displayArrowUp" />
                        <img id="downArrow" class="fright" src="../../assets/chev-down.png" alt="" v-if="displayArrowDown" />
                    </span>
                </h3>
            </div>
            <ul
                id="typeOfShades"
                class="flexContainer fw-w jc-c mobileNot listNone"
                v-if="totalActiveShades !== 0 || totalZoneShades !== 0 || totalAllShades !== 0"
            >
                <li class="ff-light" @click="displayActiveShades" :class="{ active: activeShades }">
                    {{ $t("shades.allActive") }} ({{ totalActiveShades }})
                </li>
                <li class="ff-light" @click="displayZoneShades" :class="{ active: zoneShades }">
                    {{ $t("shades.zoneShades") }} ({{ totalZoneShades }})
                </li>
                <li class="ff-light" @click="displayAllShades" :class="{ active: allShades }">{{ $t("shades.allShades") }} ({{ totalAllShades }})</li>
            </ul>
            <h2 class="txtCenter ff-medium uppercase" v-if="totalActiveShades === 0 && totalZoneShades === 0 && totalAllShades === 0">
                {{ $t("shades.noShades") }}
            </h2>
            <div id="shadesPosition" class="rel shadesPosition flexContainer fw-w mobileNot">
                <div
                    v-for="(shade, index) in getRelatedShades"
                    :key="shade.id"
                    @mouseleave="mouseLeave"
                    class="shades size1of6 flexContainer fd-c ai-c jc-fs rel"
                    :class="shadeClass(index)"
                    v-if="activeShades === shade.activated || allShades || zoneShades"
                >
                    <div class="colors" :class="{ animation: shade.isDiscontinued == false || shade.isDiscontinued == null }">
                        <div
                            :class="{
                                colorCertifAct: shade.isCertified == true && shade.activated == true,
                                colorCertiDis: shade.isCertified == true && shade.isDiscontinued == true
                            }"
                        >
                            <div
                                v-on:mouseover="hoverInfo(shade.id);"
                                @click="editShade(shade.id);"
                                v-if="shade.properties.hasOwnProperty('colors')"
                                class="circle fleft pointer"
                                :style="'background:' + shade.properties.colors.color.value + ';'"
                                :class="{ shadeActive: shade.activated == true, shadeDisabled: shade.isDiscontinued == true }"
                            ></div>
                            <div
                                v-on:mouseover="hoverInfo(shade.id);"
                                @click="editShade(shade.id);"
                                v-else=""
                                class="circle fleft"
                                :style="'background: #fff;'"
                                :class="{ shadeActive: shade.activated == true, shadeDisabled: shade.isDiscontinued == true }"
                            ></div>
                        </div>
                        <div
                            :id="'shadeNames_' + shade.id"
                            :class="{
                                whenCertified: shade.isCertified === true,
                                whenNotCertified: shade.isCertified === null || shade.isCertified === false
                            }"
                        >
                            <span v-if="shade.properties.hasOwnProperty('number')">{{ shade.properties.number.numb1.value }} </span> {{ shade.name }}
                            <br />
                            <span v-if="shade.properties.hasOwnProperty('reference') && shade.properties.reference.hasOwnProperty('client_ref1')">{{
                                shade.properties.reference.client_ref1.value
                            }}</span>
                        </div>
                    </div>
                    <ShadeHover v-if="currentShade.id == shade.id" :index="index" :shade="currentShade"></ShadeHover>
                </div>

                <loader :loading="loading"></loader>
            </div>
        </section>
        <section id="teinteMobile" class="mobileOnly full rel" v-if="displayShades">
            <div>
                <select id="shades" class="block center ff-medium" v-model="bonjour" @change="typeOfShades();">
                    <option> {{ $t("shades.allActive") }} ({{ totalActiveShades }})</option>
                    <option> {{ $t("shades.zoneShades") }} ({{ totalZoneShades }})</option>
                    <option> {{ $t("shades.allShades") }} ({{ totalAllShades }})</option>
                </select>
                <div class="mobileOnly">
                    <div class="flexContainer m-fw-w m-jc-sb ">
                        <div
                            v-for="(shades, index) in getRelatedShades"
                            :key="shades.properties.colors.color.value"
                            class="shades size1of2"
                            :class="shadeClass(index)"
                            v-if="activeShades === shades.activated || allShades || zoneShades"
                        >
                            <div class="colors">
                                <div
                                    class="circle center"
                                    exact
                                    :style="'background:' + shades.properties.colors.color.value + ';'"
                                    :class="{ shadeActive: shades.activated == true, shadeDisabled: shades.activated == false }"
                                ></div>
                                <p class="txtCenter" v-if="shades.properties.hasOwnProperty('number')">
                                    <span class="colorNameMob ff-light">{{ shades.properties.number.numb1.value }} {{ shades.name }}</span>
                                </p>
                            </div>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <CreateShade v-if="showModal" @hide="modalClose($event);"></CreateShade>
        <EditShade v-if="showEditShade" @hideEditShade="modalClose($event);"></EditShade>
    </main>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CreateShade from "../admin/CreateShade.vue";
import EditShade from "../admin/EditShade.vue";
import Globals from "../globals.js";
import httpService from "../../components/service";
import loader from "../loader/loader";
import ShadeHover from "./ShadeHover";
import { bus } from "../../main";

export default {
    data() {
        return {
            showModal: false,
            showEditShade: false,
            loading: null,
            displayShades: false,
            displayArrowUp: false,
            displayArrowDown: true,
            activeShades: true,
            zoneShades: false,
            allShades: false,
            canEdit: false,
            showShade: false,
            totalAllShades: null,
            totalActiveShades: null,
            totalZoneShades: null,
            actShades: null,
            colorName: "colorName",
            bonjour: "",
            teinteDetails: null,
            teintedet: false,
            actionUrl: "/admin/components/" + this.$route.params.id + "/import-shades",
            uploadFieldName: "file",
            currentShade: { id: null }
        };
    },
    components: {
        CreateShade,
        EditShade,
        loader,
        ShadeHover
    },
    watch: {},
    methods: {
        ...mapActions({
            setEditShadeID: "shade/setEditShadeID",
            getRelatedShadesInfosAction: "shade/getRelatedShadesInfosAction"
        }),

        mouseLeave() {
            this.teintedet = false;
            this.currentShade = {};
        },
        init() {
            for (let i in this.getRelatedShades) {
                if (this.getRelatedShades[i].isCertified === true) {
                    let elt = document.getElementById("shadeNames_" + this.getRelatedShades[i].id);
                    if (elt) elt.classList.remove("textShade");
                }
            }
        },
        hoverInfo(id) {
            this.currentShade = this.getRelatedShadesInfos[id];
            this.teinteDetails = id;
            this.teintedet = true;
        },
        modalClose(close) {
            this.showModal = close;
            this.showEditShade = close;
        },
        bordered(index) {
            return (index + 1) % 6 ? "bordered" : "";
        },
        row(index) {
            return index + 1 <= 6 ? "firstRow" : "secondRow";
        },
        shadeClass(index) {
            return this.bordered(index) + " " + this.row(index);
        },
        row2(index) {
            return index + 1 <= 5 ? "firstRow" : "";
        },
        showShades() {
            this.displayShades = !this.displayShades;
            this.displayArrowUp = !this.displayArrowUp;
            this.displayArrowDown = !this.displayArrowDown;
        },
        async displayActiveShades() {
            this.activeShades = true;
            this.zoneShades = false;
            this.allShades = false;
            this.showShade = true;
            this.loading = !this.loading;
            let getShadeObject = {
                id: this.$route.params.id,
                zone: "1",
                disablecampaign: "0",
                isactivated: "1"
            };
            await this.$store.dispatch("shade/getRelatedShades", getShadeObject);
            for (let a in this.getRelatedShades) {
                if (this.getRelatedShades[a].activated === true) {
                    this.actShades += 1;
                }
            }
            this.totalActiveShades = this.getRelatedShades.length;
            this.loading = false;
            this.getRelatedShadesInfosAction(getShadeObject);
        },
        async displayZoneShades() {
            this.zoneShades = true;
            this.activeShades = false;
            this.allShades = false;
            this.loading = !this.loading;
            let getShadeObject = {
                id: this.$route.params.id,
                zone: "1",
                disablecampaign: "1",
                isactivated: "1"
            };
            await this.$store.dispatch("shade/getRelatedShades", getShadeObject);
            for (let a in this.getRelatedShades) {
                if (this.getRelatedShades[a].activated === true) {
                    this.actShades += 1;
                }
            }
            this.totalZoneShades = this.getRelatedShades.length;
            this.loading = false;
            this.getRelatedShadesInfosAction(getShadeObject);
        },
        async displayAllShades() {
            this.allShades = true;
            this.zoneShades = false;
            this.activeShades = false;
            let getShadeObject = {
                id: this.$route.params.id,
                zone: "0",
                disablecampaign: "1",
                isactivated: "1"
            };

            this.loading = !this.loading;
            await this.$store.dispatch("shade/getRelatedShades", getShadeObject);
            for (let a in this.getRelatedShades) {
                if (this.getRelatedShades[a].activated === true) {
                    this.actShades += 1;
                }
            }
            this.totalAllShades = this.getRelatedShades.length;
            this.loading = false;
            this.getRelatedShadesInfosAction(getShadeObject);
        },
        typeOfShades() {
            if (this.bonjour === this.$t("shades.allActive") + " (" + this.actShades + ")") {
                this.displayActiveShades();
            } else if (this.bonjour === this.$t("shades.zoneShades") + " (" + this.totalZoneShades + ")") {
                this.displayZoneShades();
            } else if (this.bonjour === this.$t("shades.allShades") + " (" + this.totalAllShades + ")") {
                this.displayAllShades();
            }
        },
        modalShades() {
            this.showModal = true;
        },
        uploadFile(formData) {
            this.loading = true;
            let prom = httpService.upload(this.actionUrl, formData);
            prom.then(resp => {
                this.loading = false;
                if (resp.code && resp.code === 400) {
                    // exception back always return 400
                    this.dialogError(resp.message);
                    this.resetInput();
                } else if (resp.success === false) {
                    // import has error
                    this.$swal({
                        text: this.$t("modalImportFile.errorImportTxt"),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "red",
                        confirmButtonText: this.$t("modalImportFile.errorImportConfirmBtnTxt"),
                        cancelButtonText: this.$t("modalImportFile.errorImportCancelBtnTxt")
                    })
                        .then(result => {
                            if (result === true) {
                                window.open(Globals.getBaseUrl() + resp.log_file);
                            }
                        })
                        .catch(() => {});
                } else if (resp.success === true) {
                    // import success
                    this.$swal({
                        html: this.$t("modalImportFile.successImportTxt", {
                            count: resp.response.count,
                            componentType: this.$t("shades.label")
                        }),
                        type: "success",
                        showCancelButton: false,
                        confirmButtonColor: "green",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: this.$t("modalImportFile.successImportConfirmBtnTxt")
                    }).then(result => {
                        if (result === true) {
                            location.reload();
                        }
                    });
                }
            });
        },
        onSubmit(elt) {
            const formData = new FormData();
            formData.append("file", elt.files[0]);
            this.uploadFile(formData);
        },
        chooseFiles() {
            this.$refs.fileUpload.click();
        },
        editShade(shadeId) {
            this.setEditShadeID(shadeId);
            this.showEditShade = true;
        }
    },
    computed: {
        ...mapGetters({
            getAllShades: "shade/getAllShades",
            getShadesLength: "shade/getShadesLength",
            getRelatedShades: "shade/getRelatedShades",
            getRelatedShadesInfos: "shade/getRelatedShadesInfos"
        })
    },
    async created() {
        await this.displayAllShades();
        await this.displayZoneShades();
        await this.displayActiveShades();
        await this.init();
        bus.$on("editShade", shadeId => {
            this.editShade(shadeId);
        });
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

.editShade {
    left: 85px;
    top: 18px;
    margin-left: 30%;
}

.whenCertified {
    font-family: Roboto;
    font-size: 14px;
    margin-left: 65px;
    margin-top: -47px;
}

.whenNotCertified {
    text-transform: lowercase;
    margin-left: 65px;
    font-family: Roboto;
    font-size: 14px;
    margin-top: 10px;
}

.campaign {
    padding: 10px;
    font-size: 12px;
}

.footerHover {
    height: 3px;
}

.zoneCampaign {
    margin-top: 10px;
    font-family: Roboto;
    font-weight: bold;
}

.label {
    font-family: Roboto;
    font-weight: bold;
    font-size: 12px;
}

.shadeName {
    font-family: "Oswald", Sans-Serif;
    color: #fff;
    font-size: 20px;
    padding-left: 10px;
    display: block;
    padding-top: 4px;
}

.shadeBack {
    width: 100%;
    height: 30px;
}

.infoTeinte {
    position: absolute;
    margin-top: 60px;
    width: auto;
    height: auto;
    @extend %second-bloc;
    z-index: 50;
}

@keyframes colorCircle {
    from {
        width: 45px;
        height: 45px;
        top: 0px;
        left: 0px;
    }
    50% {
        width: 51px;
        height: 51px;
        top: -4px;
        left: -4px;
    }
    to {
        width: 50px;
        height: 50px;
        top: -3px;
        left: -3px;
    }
}

#teinte {
    @extend %second-bloc;
    @extend %second-text;

    margin-right: 30px;
    margin-left: 30px;

    #teinteDesktop {
        #title {
            font-size: 18px;
            margin-top: 30px;
        }

        #edit {
            font-size: 1.4rem;
            right: 0;
            top: -7px;
            margin-right: 50px;
        }

        #typeOfShades {
            margin-bottom: 40px;
            padding: 0;

            li {
                font-size: 1.4rem;
                margin-right: 20px;
                color: #95989a;
                cursor: pointer;
                padding-bottom: 6px;
                transition: all 0.3s;

                &:last-child {
                    margin-right: 0px;
                }

                &:hover {
                    @extend %second-text;
                    transition: all 0.3s;
                }

                &.active {
                    @extend %second-text;
                    font-weight: 500;
                    border-bottom: 1px solid #343434;
                    @extend %second-border-color;
                }
            }
        }
    }

    #teinteMobile {
        #upArrow {
            height: 15px;
            width: 15px;
            margin-top: -35px;
            margin-right: 10px;
        }

        #downArrow {
            height: 15px;
            width: 15px;
            margin-top: -35px;
            margin-right: 10px;
        }

        #shadeLink {
            text-decoration: none;
        }

        #head {
            margin-top: -30px;
            margin-right: 60px;
        }
    }

    .circle {
        border-radius: 50%;
        width: 45px;
        height: 45px;
        margin: 3px;
    }

    .colors {
        width: 100%;
        margin-bottom: 50px;
        position: relative;
    }

    .animation {
        &:hover {
            .shadeActive {
                // border-radius: 50%;
                //position: absolute;
                //width: 50px;
                //height: 50px;
                //top: -2px;
                //left: -2px;
                //animation-name: colorCircle;
                //animation-iteration-count: 1;
                //transition: all 0.5s;
            }
        }
    }

    .colorCertifAct {
        border: 1px solid #343434;
        border-radius: 50%;
        display: inline-block;
        width: 53px;
        height: 53px;
        z-index: 200;
    }

    .colorNameMob {
        font-size: 14px;
    }

    .shadeActive {
        border-radius: 50%;
        width: 45px;
        height: 45px;
        top: 1px;
        left: 1px;

        &:first-of-type + .colorName {
            position: relative;
            left: 30px;
        }
    }

    .colorCertiDis {
        border-radius: 50%;
        width: 35px;
        height: 35px;
        margin-top: 8px;
        margin-left: 8px;
    }

    .shadeDisabled {
        border-radius: 50%;
        width: 30px;
        height: 30px;
        margin-top: 1px;
        margin-left: 1px;

        &:first-of-type + .colorName {
            padding-left: 0px;
            left: 30px;
            color: #95989a;
        }
    }
}

.shadesPosition {
    padding-left: 70px;
}

@media only screen and (max-width: 767px) {
    #teinte {
        margin: 0px 20px;

        #teinteDesktop {
            #title {
                margin: 15px 0px;

                .arrows {
                    right: 10px;
                    top: 6px;

                    .dark & {
                        top: 0px;
                        background: white;
                        padding: 5px;
                    }
                }
            }
        }

        #teinteMobile {
            padding-left: 15px;
            padding-right: 15px;

            #shades {
                border: none;
                border-bottom: 1px solid #343434;
                //background-color: transparent;
                margin-bottom: 20px;
                font-size: 1.4rem;
                width: 100%;
                height: 30px;
                border-radius: 0px;
                text-transform: uppercase;
            }
        }

        .circle {
            border-radius: 50%;
            width: 45px;
            height: 45px;
            position: initial;
        }

        .colors {
            &:hover {
                .shadeActive {
                    animation: none;
                    transition: none;
                    position: initial;
                    width: 45px;
                    height: 45px;
                }
            }
        }

        .shadeActive {
            border-radius: 50%;
            width: 45px;
            height: 45px;
            margin: 0 auto;
        }

        .shadeDisabled {
            border-radius: 50%;
            width: 30px;
            height: 30px;
            margin-top: 8px;
            margin-left: 50px;

            &:first-of-type + .colorName {
                padding-left: 32px;
            }
        }
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    .shades {
        width: 33.33333%;
    }
    #downArrow {
        position: relative;
        top: 5px;
        margin-left: 5px;
    }
}

.uploader {
    &-form {
        font-size: 1.4rem;
        right: 0;
        top: -7px;
        margin-right: 250px;
    }
}
</style>



// WEBPACK FOOTER //
// Teinte.vue?125c2978